<mat-card style="padding: 14px !important;border-radius: 10px; margin-bottom: 18px !important;"
  class="product-card-container box-shadow-md swiper-slide-body" id="test" [ngClass]="{
    'small-content': environmentVariables?.PRODUCT_CARD_STYLE == 'small',
    'medium-content':
      environmentVariables?.PRODUCT_CARD_STYLE == 'medium' ||
      (environmentVariables?.PRODUCT_CARD_STYLE == 'large' &&
      viewLocation == 'search'),
    'large-content':
      environmentVariables?.PRODUCT_CARD_STYLE == 'large' &&
      viewLocation != 'search',
    'english-direction': lang == 'en',
    'arabic-direction': lang == 'ar'
  }">
  <mat-card-content>
    <div class="img-brand" [ngClass]="lang == 'en' ? 'right-0' : 'left-0'" 
      *ngIf="product?.brand && environmentVariables?.SHOW_BRAND_ON_PRODUCT">
      <img loading="lazy" [src]="product?.brand.image" [alt]="product?.brand.image"
        default="./assets/images/placeholder200.jpg" 
        onError="this.src='./assets/images/placeholder200.jpg';" />
    </div>

    <div class="chip-container lh1 pointer-event-none"
	    [ngStyle]="{ 'top': '5px'}" 
	  >
      <mat-chip *ngIf="!product.in_stock ||
        (product.stock == 0 && product.stock != null)" 
        class="chip-item my-1 pointer-event-none">
        {{ "orders.outOfStock" | translate }}
      </mat-chip>

      <mat-chip 
        *ngIf="product?.discount_price !== null &&
          !product?.promotion &&
          product.discount_price != product.price" 
          class="chip-item my-1 pointer-event-none" 
		    [ngClass]="{
          'label-small lh-sm-12 lh-sm-rtl-16' : environmentVariables?.LABEL_SIZE !== 'large',
          'py8': environmentVariables?.LABEL_SIZE === 'large'}"
          tabindex="-1">
        <span 
		      [ngClass]="{'label-font-size-small' : environmentVariables?.LABEL_SIZE !== 'large' }" > 
          {{ ((product?.price - product?.discount_price) /
          product?.price) * 100 | number: "1.0-0" }} %
        </span>
        <span *ngIf="environmentVariables?.ENABLE_SHOW_OFF_IN_PRODUCT_LABEL" 
		      [ngClass]="{'label-font-size-small' : environmentVariables?.LABEL_SIZE !== 'large' }">
          {{ "productDetails.off" | translate }}
        </span>
      </mat-chip>

      <mat-chip *ngIf="product?.discount_price !== null && product?.promotion" 
        class="chip-item my-1 pointer-event-none"
		    [ngClass]="{'label-font-size-small' : environmentVariables?.LABEL_SIZE !== 'large' }"
        tabindex="-1">
        <ng-container *ngIf="lang == 'en'">
          {{ product?.promotion_en }} OR
          {{ ((product?.price - product?.discount_price) /
          product?.price) * 100 | number: "1.0-0" }} %
          <span *ngIf="environmentVariables?.ENABLE_SHOW_OFF_IN_PRODUCT_LABEL">
            OFF
          </span>
        </ng-container>
        <ng-container *ngIf="lang == 'ar'">
          {{ product?.promotion_ar }} أو خصم
          {{ ((product?.price - product?.discount_price) /
            product?.price) * 100 | number: "1.2-2" }} %
        </ng-container>
      </mat-chip>

      <mat-chip *ngIf="product?.preorder" class="chip-item my-1 pointer-event-none" tabindex="-1"
	  [ngClass]="{'label-font-size-small' : environmentVariables?.LABEL_SIZE !== 'large' }">
        {{ "productDetails.preorder" | translate }}
      </mat-chip>

      <mat-chip *ngIf="product?.available_soon" class="chip-item my-1 pointer-event-none" tabindex="-1" [ngClass]="{'label-font-size-small' : environmentVariables?.LABEL_SIZE !== 'large' }">
        {{ "productDetails.availableSoon" | translate }}
      </mat-chip>

      <mat-chip *ngIf="product?.type === 2" class="chip-item my-1 pointer-event-none" tabindex="-1"
	  [ngClass]="{'label-font-size-small' : environmentVariables?.LABEL_SIZE !== 'large' }">
        {{ "productDetails.bundle" | translate }}
      </mat-chip>

      <mat-chip 
        *ngIf="product?.promos?.length &&
          product?.promos[0]?.show_in_product != 0" 
          class="chip-item my-1 pointer-event-none" 
		  [ngClass]="{'label-font-size-small' : environmentVariables?.LABEL_SIZE !== 'large' }"
          tabindex="-1">
        {{ product?.promos[0]?.name }}
      </mat-chip>

      <mat-chip 
        *ngIf="product?.commission_amount &&
          user?.is_affiliate && product?.commission_amount != 0" 
          class="chip-commission-amount my-1" tabindex="-1"
		  [ngClass]="{'label-font-size-small' : environmentVariables?.LABEL_SIZE !== 'large' }">
        {{ "orders.commission" | translate }} :
        {{ product?.commission_amount | number: "1.2-2" }}
        {{
          lang == "en"
          ? environmentVariables?.CURRENCY_CODE_EN
          : environmentVariables?.CURRENCY_CODE_AR
        }}
      </mat-chip>

      <mat-chip *ngIf="product?.promotion && !product?.direct_discount" class="chip-item my-1 pointer-event-none"
	  [ngClass]="{'label-font-size-small' : environmentVariables?.LABEL_SIZE !== 'large' }"
        tabindex="-1">
        {{
        lang == "en" ? product?.promotion_en : product?.promotion_ar
        }}
      </mat-chip>
    </div>

    <div class="mat-upper product-image">
      <a *ngIf=" environmentVariables?.PRODUCT_TYPE == 'main'" (click)="setParentID(product?.parent_id)"
        [routerLink]="['/' + lang + '/' + product?.product_variants[0]?.slug]" class="p-link pointer no-outline">
        <img loading="lazy" [src]="product?.image" [alt]="product?.name" mat-card-image
          default="./assets/images/placeholder200.jpg" onError="this.src='./assets/images/placeholder200.jpg';"
          class="my-0 mx-auto no-outline w-100 image-default" />

        <img loading="lazy" [src]="product?.images[0]?.url || product?.image"
          [alt]="product?.images[0]?.url || product?.image" mat-card-image default="./assets/images/placeholder200.jpg"
          onError="this.src='./assets/images/placeholder200.jpg';" class="my-0 mx-auto no-outline w-100 image-hover" />
      </a>

      <a *ngIf=" environmentVariables?.PRODUCT_TYPE !== 'main'" (click)="setParentID(product?.parent_id)"
        [routerLink]="['/' + lang + '/' + product?.slug]" class="p-link pointer no-outline">
        <img loading="lazy" [src]="product?.image" [alt]="product?.name" mat-card-image
          default="./assets/images/placeholder200.jpg" onError="this.src='./assets/images/placeholder200.jpg';"
          class="my-0 mx-auto no-outline w-100 image-default" />

        <img loading="lazy" [src]="product?.images[0]?.url || product?.image" [alt]="product?.name" mat-card-image
          default="./assets/images/placeholder200.jpg" onError="this.src='./assets/images/placeholder200.jpg';"
          class="my-0 mx-auto no-outline w-100 image-hover" />
      </a>
    </div>

    <div class="product-content relative">
      <div class="d-flex flex-column">
        <p class="category-item mb-2" [ngClass]="{ 'direction-ar': lang == 'ar' }"
          *ngIf="environmentVariables?.SHOW_CATEGORY_ON_PRODUCT_CARD">
          {{
            lang === "en"
            ? product.category?.name
            : product.category?.name_ar
          }}
          <ng-container *ngIf="product?.optional_category">,
            {{
              lang === "en"
              ? product?.optional_category?.name
              : product?.optional_category?.name_ar
            }}
          </ng-container>
        </p>
      </div>
    </div>

    <div class="product-name lh-130 lh-rtl-135">
      <ng-container *ngIf="environmentVariables?.PRODUCT_TYPE != 'main'">
        <p class="product-title fade mb-0 pointer" [class]="{
                        'direction-ar': lang == 'ar',
                        'one-line-name':
                            environmentVariables.ENABLE_PRODUCT_NAME_IN_CARD_ONE_LINE,
                        'multiple-line-name':
                            !environmentVariables.ENABLE_PRODUCT_NAME_IN_CARD_ONE_LINE
                    }">

          <a (click)="setParentID(product?.parent_id)" [routerLink]="['/' + lang + '/' + product?.slug]"
            class="no-outline">
            {{ lang == "en" || !product?.name_ar ? product?.name_en : product?.name_ar }}
          </a>
        </p>
      </ng-container>

      <ng-container *ngIf="environmentVariables?.PRODUCT_TYPE == 'main'">
        <h5 class="product-title fade mb-0 pointer" [ngClass]="{
                        'direction-ar': lang == 'ar',
                        'one-line-name':
                            environmentVariables.ENABLE_PRODUCT_NAME_IN_CARD_ONE_LINE,
                        'multiple-line-name':
                            !environmentVariables.ENABLE_PRODUCT_NAME_IN_CARD_ONE_LINE
                    }">

          <a (click)="setParentID(product?.parent_id)"
            [routerLink]="['/' + lang + '/' + product?.product_variants[0].slug]" class="no-outline">
            {{ lang == "en" || !product?.name_ar ? product?.name_en : product?.name_ar }}
          </a>
        </h5>
      </ng-container>

      <div class="d-flex rate-container"  
      *ngIf="environmentVariables?.ENABLE_PRODUCT_RATE"  
        [ngClass]=" lang == 'ar'? 'direction-ar': ''">
        <bar-rating [rate]="product?.rate" [max]="5" [readOnly]="true"></bar-rating>
          <div style="font-size: 18px;" class="mx-1">
           <span class="" style="color: gray;"> {{getRate(product)}}</span> <span style="color: gray;">{{ '(' + product?.rate_count + ')' }}</span>  
          </div>
      </div>
    </div>

    <ng-container 
      *ngIf="
        environmentVariables?.SHOW_PRODUCT_VARIANTS_OPTIONS &&
        environmentVariables?.PRODUCT_TYPE === 'variant'
      ">
      <p class="text-left text-system-gray font-medium mb-0">
        {{getVariantOptionName(product)}}
      </p>
    </ng-container>


    <div class="item-price mt-2" [dir]="lang === 'en' ? 'ltr' : 'rtl'">
      <div class="my-2" class="d-flex w-100" 
        [ngClass]="{
          'one-line-price align-items-center':
            environmentVariables?.ENABLE_DISCOUNT_PRICE_SAME_LINE,
          'flex-column align-items-start multiple-line-price':
            !environmentVariables?.ENABLE_DISCOUNT_PRICE_SAME_LINE}">
        <!-- main price -->
        <div 
          *ngIf="(product?.in_stock ||
            environmentVariables?.SHOW_OUT_STOCK_PRODUCT_PRICE) &&
            environmentVariables?.GUEST_CAN_VIEW_PRICES" 
          [ngClass]="{
            'price-ar': lang == 'ar',
            'config-price-before-discount': product?.discount_price &&
              environmentVariables?.PRODUCT_PRICE_BEFORE_DISCOUNT_TEXT_COLOR,
            'config-price-color':
              environmentVariables?.PRODUCT_PRICE_TEXT_COLOR &&
              !product?.discount_price }" 
          class="defult-price-color payment-with-discount-container fs-xs-11 mr-2">
          <ng-container *ngIf="product?.price">
            {{ (product?.discount_price !== null
              ? product?.discount_price
              : product?.price) | number
            }}
            {{ lang == "en"
              ? environmentVariables?.CURRENCY_CODE_EN
              : environmentVariables?.CURRENCY_CODE_AR
            }}
          </ng-container>
        </div>
        
        <div fxLayout="row">
          <!-- discount price -->
          <div [ngClass]="{'text-decoration-line-through lh1': product?.discount_price && 
            (product?.in_stock || environmentVariables?.SHOW_OUT_STOCK_PRODUCT_PRICE) &&
            environmentVariables?.GUEST_CAN_VIEW_PRICES}"
            [ngStyle]="{ 'color': product?.discount_price && 
              (product?.in_stock || environmentVariables?.SHOW_OUT_STOCK_PRODUCT_PRICE) &&
              environmentVariables?.GUEST_CAN_VIEW_PRICES ? 'red' : ''}">
            <div style="position: relative;
              text-decoration: none !important;" 
              class="fs-12 fs-xs-10 bottom3"
              *ngIf="product?.discount_price &&
                (product?.in_stock ||
                environmentVariables?.SHOW_OUT_STOCK_PRODUCT_PRICE) &&
                environmentVariables?.GUEST_CAN_VIEW_PRICES" 
              [ngClass]="{ 
                'config-price-after-discount':
                  product?.discount_price &&
                  environmentVariables?.PRODUCT_PRICE_AFTER_DISCOUNT_TEXT_COLOR,
                'config-price-color':
                  environmentVariables?.PRODUCT_PRICE_TEXT_COLOR,
                'defult-price-color-after-discount':
                  !environmentVariables?.PRODUCT_PRICE_AFTER_DISCOUNT_TEXT_COLOR &&
                  product?.discount_price,
                'price-ar': environmentVariables?.ENABLE_DISCOUNT_PRICE_SAME_LINE}">
              {{ product?.price | number }}
              {{
                lang == "en"
                ? environmentVariables?.CURRENCY_CODE_EN
                : environmentVariables?.CURRENCY_CODE_AR
              }}
            </div>
          </div>
  
          <!-- info icon -->
          <div class="payment-with-discount-container position-relative ml-2"
            *ngIf="product?.payment_methods_discount_name_en">
            <div class="discount-method-information"
              [ngClass]="{
                'reposition':
                  environmentVariables?.ENABLE_DISCOUNT_PRICE_SAME_LINE}"
            >
              <p style="height: 16px !important;">i</p>
              <div class="hover-info">
                {{
                  lang == "en"
                  ? product?.payment_methods_discount_name_en
                  : product?.payment_methods_discount_name_ar
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div [ngClass]="{ 'direction-ar': lang == 'ar' }" class="up-to" *ngIf="
                environmentVariables?.ENABLE_PRODUCT_UPTO_IN_CARD &&
                environmentVariables?.PRODUCT_TYPE == 'main'
            ">
      <ng-container *ngIf="
                    product?.variant_max_price &&
                    ((product?.discount_price &&
                        product?.variant_max_price > product?.discount_price) ||
                        (!product?.discount_price &&
                            product?.variant_max_price > product?.price))
                ">
        {{ lang == "en" ? " up to " : " حتى " }}
        {{ product?.variant_max_price }}
        {{
        lang == "en"
        ? environmentVariables.CURRENCY_CODE_EN
        : environmentVariables.CURRENCY_CODE_AR
        }}
      </ng-container>
    </div>

    <ng-container *ngIf="
                environmentVariables?.PRODUCT_TYPE == 'main' &&
                environmentVariables?.SHOW_PRODUCT_VARIANTS_OPTIONS
            ">
      <div class="image-gallary-container" [ngClass]="{ 'direction-ar': lang == 'ar' }"
        *ngIf="variantValues && variantValues.length > 0">
        <div class="gallery-image" *ngFor="let value of variantValues.slice(0, variantsLimit)" (mouseenter)="
                        variantOptions?.type == '3' ||
                        variantOptions?.type == '4'
                            ? setChossenData(value)
                            : ''
                    " [ngClass]="{
                        'text-box': variantOptions?.type == '1',
                        'color-box': variantOptions?.type == '2',
                        'image-box':
                            variantOptions?.type == '3' ||
                            variantOptions?.type == '4'
                    }" [style.background-color]="
                        variantOptions?.type == '2'
                            ? value?.color_code
                            : 'transparent'
                    " [style.border]="
                        variantOptions?.type == '2' ? '1px solid #000' : ''
                    ">
          <span *ngIf="variantOptions?.type == '1'" style="font-size: 12px; line-height: 1">{{ value?.name }}</span>
          <span *ngIf="variantOptions?.type == '2'"></span>
          <img loading="lazy" *ngIf="
                            variantOptions?.type == '3' ||
                            variantOptions?.type == '4' ||
                            value?.image
                        " [src]="value.image" [alt]="value.image"
            onError="this.src='./assets/images/placeholder200.jpg';" default="./assets/images/placeholder200.jpg" />
        </div>
        <a (click)="setParentID(product?.parent_id)" [routerLink]="['/' + lang + '/' + product?.slug]"
          *ngIf="variantValues.length > variantsLimit" class="gallery-image plus-variants">
          +{{ variantValues.length - variantsLimit }}
        </a>
      </div>
    </ng-container>
  </mat-card-content>

  <mat-card-footer>
    <div [ngClass]="lang == 'ar' ? 'parent-arabic-position' : ''" class="card-footer">
      <div class="card-actions d-flex align-items-center">
        <div class="favorite-icon-container d-flex align-items-center" 
          [ngClass]="environmentVariables?.FAVORITE_ICON_POSITION == 'top'
            ? 'favorite-top-location'
            : ''">
          <mat-icon class="material-icons d-flex favorite pointer" 
            (click)="addToFavouriteList(
              environmentVariables?.PRODUCT_TYPE == 'main'
                ? product?.product_variants[0]
                : product,
              environmentVariables?.PRODUCT_TYPE)" 
            [ngClass]="
              product?.is_favourite ||
              product?.product_variants[0]?.is_favourite
                ? 'active-icon'
                : ''">
            favorite
          </mat-icon>
          <div class="loader-container" *ngIf="product?.favouriteLoading">
            <app-loading></app-loading>
          </div>
        </div>

        <button *ngIf="!environmentVariables?.DISABLE_COMPARE" 
          class="compare-icon-container px-0 d-flex align-items-center"
          title="Compare" 
          (click)="
            addToCompareList(
              environmentVariables?.PRODUCT_TYPE == 'main'
                ? product?.product_variants[0]
                : product,
              environmentVariables?.PRODUCT_TYPE
            )
          " 
          [ngClass]="lang == 'ar' ? 'arabic-position' : ''" 
          [disabled]="product?.toggleCompareLoading"
          [style.cursor]="
                        product?.toggleCompareLoading
                            ? 'not-allowed'
                            : 'pointer'
                    ">
          <mat-icon [ngClass]="
                            product?.is_compare ||
                            product?.product_variants[0]?.is_compare
                                ? 'active-icon'
                                : ''
                        " class="material-icons">
            compare
          </mat-icon>
          <div class="loader-container" *ngIf="product?.toggleCompareLoading">
            <app-loading></app-loading>
          </div>
        </button>
      </div>

      <app-control-add-to-cart *ngIf="product" [product]="product" [styleCard]="true" [styleCardHomeAr]="true"
        [redirectToProduct]="redirectToProduct">
      </app-control-add-to-cart>
    </div>
  </mat-card-footer>
</mat-card>